import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footernew = () => {
  return (
    <footer className="section-padding footer-new mt-auto" >
      <Container>
        <Row className="align-items-center">
          <Col md={2}>
            <img src="/images/footer-logo.png" alt="Footer logo" />
          </Col>
          <Col md={8}>

          </Col>
          <Col md={2} >
            <div className="footer-links">
              <ul>
                <li><a href={`${process.env.REACT_APP_WP_SITE_ROOT}/privacy-policy/`}>CGV 111</a></li>
                {/* <li><a href="#">Crédits</a></li> */}
              </ul>
            </div>
          </Col>
        </Row>
        <Row>
          <Col></Col>
          <Col md={8}>
            <div className="address text-center">
              <p>
                <b>
                  E-SLIDES une marque de ALEOU<br/>
                  <span>5 allée des Acacias - 77100 MAREUIL-LES-MEAUX - FRANCE Tel : 01 64 33 33 33 - Fax : 01 64 33 40 31<br/>
                  Capital Social : 550000 € - N° TVA intracom : FR 23 431 925 031 Siret : 431 925 031 00020 - APE 8230Z</span><br/>
                  <span className="designby">Design by <a href="https://zeliedethorey.com/" rel="noopener noreferrer" target="_blank">Zélie Dethorey</a></span>
                </b>
              </p>
            </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footernew